import { Link } from "@remix-run/react";
import type { FunctionComponent } from "react";

import clsx from "clsx";
import type { PostListItem } from "~/database/post.model";
import { dateDisplay } from "~/utils/dateDisplay";

interface PostItemTextProps {
  data: PostListItem;
}

const PostItemText: FunctionComponent<
  PostItemTextProps
> = ({ data }) => {
  return (
    <div className="">
      <Link
        to={`/${data.user_display_id}/posts/${data?.display_id}/`}
        className={clsx(
          "relative",
          "z-10",
          "block",
          "font-bold",
          "text-15",
          "min-h-50",
          "flex",
          "items-center",
          "items-center",
        )}
      >
        {data?.title}
      </Link>
      <div
        className={clsx(
          "flex",
          "items-center",
          "tracking-1",
          "text-sm",
          "text-gray-400",
          "text-12",
          "mt-5",
        )}
      >
        <div
          className={clsx(
            "font-bold",
            "line-clamp-1",
          )}
        >
          <Link to={`/user/${data?.user_id}/`}>
            {data?.user_name}
          </Link>
        </div>
        <div
          className={clsx(
            "pl-8",
            "ml-8",
            "border-l",
            "whitespace-nowrap",
          )}
        >
          {dateDisplay(
            data?.first_published_at ??
              data?.created_at,
          )}
        </div>
      </div>
    </div>
  );
};

export default PostItemText;
